
const baseURL = 'https://alvand.iotfig.com/backend/api/v1/';




// const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_BASE_URL : process.env.REACT_APP_DEV_API_URL;


export {baseURL}